<template>
  <div ref="appFieldWidget" class="app-field-widget_fd">

    <span v-if="title" class="fd_title"
      :class="{ 'fd_title--block': typeLocal === 'multiline' }">
      <template v-if="typeLocal === 'person'">
        <span class="ob_title ob_title--block">
          {{ title }}<template v-if="contentLocal.length > 1"> (
          <el-tooltip
            content="Авторский вклад"
            placement="top"
            :enterable="false">
            <i class="el-icon-question"></i>
          </el-tooltip> )</template>:</span>
      </template>
      <template v-else>
        {{ title }}:
      </template>
    </span>

    <ul v-if="typeLocal === 'ul'" class="fd_ul">
      <li v-for="(el, i) in contentLocal" :key="`li-${i}`">
        {{ preRender(el) }}
      </li>
    </ul>

    <template v-else-if="typeLocal === 'option' && options">
      <template v-if="Array.isArray(contentLocal)">
        <template v-if="contentLocal.length > 1">
          <ul>
            <li v-for="(el, i) in contentLocal" :key="`option-${i}`">
              {{ options[el] }}
            </li>
          </ul>
        </template>
        <template v-else>
          {{ options[contentLocal[0]] }}
        </template>
      </template>
      <template v-else>
        {{ options[contentLocal] }}
      </template>
    </template>

    <div
      v-else-if="images.length && typeLocal === 'images'"
      class="fd_images_im">

      <div class="im_md-container swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(im, i) in images"
            :key="`image-md-${i}`"
            @click="onImageClicked(i, 'md')"
            class="swiper-slide">
            <img :src="`${$store.state.apiUrl}${im.md.url}`">
          </div>
        </div>
      </div>

      <div
        class="im_sm-container swiper-container"
        v-if="images.length > 1">
        <div class="swiper-wrapper">
          <div
            v-for="(im, i) in images"
            :key="`image-sm-${i}`"
            @click="onImageClicked(i, 'sm')"
            class="swiper-slide">
            <img :src="`${$store.state.apiUrl}${im.sm.url}`">
          </div>
        </div>
      </div>

      <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="pswp__bg"></div>
        <div class="pswp__scroll-wrap">
          <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
          </div>
          <div class="pswp__ui pswp__ui--hidden">
            <div class="pswp__top-bar">
              <div class="pswp__counter"></div>
              <button class="pswp__button pswp__button--close" title="Закрыть"></button>
              <button class="pswp__button pswp__button--fs" title="На весь экран"></button>
              <button class="pswp__button pswp__button--zoom" title="Приблизить/отдалить"></button>
              <div class="pswp__preloader">
                <div class="pswp__preloader__icn">
                  <div class="pswp__preloader__cut">
                    <div class="pswp__preloader__donut"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
              <div class="pswp__share-tooltip"></div>
            </div>
            <button class="pswp__button pswp__button--arrow--left"
                    title="Предыдущий (стрелка влево)"></button>
            <button class="pswp__button pswp__button--arrow--right"
                    title="Следующий (стрелка вправо)"></button>
            <div class="pswp__caption">
              <div class="pswp__caption__center"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ul class="fd_files_ff"
      v-else-if="['files.body', 'files.preview', 'files.legal'].indexOf(typeLocal) > -1 && objData">
      <li v-for="(el, i) in contentLocal" :key="`files-li-${i}`" class="ff_li">
        <i class="el-icon-document ff_icon"></i>

        <!-- <template
          v-if="objData.Transient.Permissions.OBJECT_DOWNLOAD
            || typeLocal === 'files.preview'">
          <a class="ff_name" @click.prevent="onFileClicked(el)">
            {{ el.Name }}</a>
        </template>
        <template v-else>
          <div class="ff_name">{{ el.Name }}</div>
        </template> -->
        <a class="ff_name"
           @click.prevent="onFileClicked(el)">
          {{ el.Name }}</a>

        <div class="ff_size" v-if="el.Size">
          {{(el.Size / (1024 * 1024)).toFixed(2) }}
          <span class="ff_size_units">МБ</span></div>

        <div class="ff_desc" v-if="el.Description">
          {{ el.Description }}</div>

        <div class="ff_markup" v-if="el.Markup">
          Фрагментов: {{ getMarkupFragments(el) }}.
          Заимствований: {{ getMarkupCitations(el) }}.
        </div>
      </li>
    </ul>

    <ul v-else-if="typeLocal === 'object'" class="ob_ul">
      <li v-for="(o, i) in objects"
        :key="`lix-${i}`" class="fo_li">
          <router-link :key="o.objectId"
            class="ob_link"
            :to="`/object/${o.objectId}`">{{ o.Title }}</router-link>
      </li>
    </ul>

    <ul v-else-if="typeLocal === 'links'" class="ob_ul">
      <li v-for="(link, i) in objects"
        :key="`lix-${i}`">
        <div v-if="link.RelationName" class='link-info'>
          {{ link.RelationName }}
        </div>
        <router-link :key="link.Link"
          v-if="link.Format === 'object'"
          class="ob_link"
          :to="`/object/${link.Link}`">{{ link.objName }}</router-link>
        <a v-if="link.Format === 'resource'"
          :href="`${link.Link}`"
          class="ob_link"
          target="_blank">
          {{ cutText(link.Link, 50) }}
         </a>
        <div v-if="link.Title" class='link-info'>
          {{ link.Title }}
        </div>
      </li>
    </ul>

    <ul v-else-if="typeLocal === 'protection-documents'" class="ob_ul">
      <li v-for="(document, i) in contentLocal"
        :key="`lix-${i}`">
        <template v-if="document.RelatedDocument">
          <div
            class="prt-document-info"
            @click="onProtDocClicked(document.RelatedDocument)">
            {{ protDocTitle(document) }}
          </div>
        </template>
        <template v-else>
          {{ protDocTitle(document) }}
        </template>
      </li>
    </ul>

    <ul v-else-if="typeLocal === 'person'" class="fd_ul">
      <template v-if="Array.isArray(contentLocal)">
        <li v-for="(el, i) in personContent" :key="`li-${i}`">
          {{ el.fio }}
          <span v-if="personContent.length > 1" class="fd_color-dark">(
            {{ el.stake }}
          )</span>
        </li>
      </template>
      <template v-else>
        <li>
          {{ person }}
          <span class="fd_color-dark">(
            {{ `${contentLocal.Stake}/1` }}
          )</span>
        </li>
      </template>
    </ul>

    <template v-else-if="typeLocal === 'inline-block'">
      <span v-for="(el, i) in contentLocal" :key="`inline-block-${i}`">
        {{ preRender(el) }}<template v-if="i+1 < contentLocal.length">,
          </template><template v-else>.</template>
      </span>
    </template>

    <span v-else>
      {{ preRender(contentLocal) }}
    </span>

    <el-dialog
      title="Охранный документ"
      class="prt-document-full"
      :visible.sync="protectionDocObj.docVisible">
      <div v-if="protectionDocObj.docInfo.DocumentNumber">
        <span class="prt-document-title">
          Охранный документ:
        </span>
        {{ protectionDocObj.docInfo.DocumentName }}
      </div>
      <div v-if="protectionDocObj.docInfo.ObjectTitle">
        <span class="prt-document-title">
          Название объекта:</span> {{ protectionDocObj.docInfo.ObjectTitle }}
      </div>
      <div v-if="protectionDocObj.docInfo.DocumentNumber">
        <span class="prt-document-title">
          Номер регистрации (свидетельства):
        </span>
        {{ protectionDocObj.docInfo.DocumentNumber }}
      </div>
      <div v-if="protectionDocObj.docInfo.DocumentRegistrationDate">
        <span class="prt-document-title">
          Дата регистрации:
        </span>
        {{ protectionDocObj.docInfo.DocumentRegistrationDate }}
      </div>
      <div v-if="protectionDocObj.docInfo.ObjectAuthors">
        <span class="prt-document-title">
          Автор{{ protectionDocObj.docInfo.ObjectAuthors.length > 1 ? 'ы' : '' }}:
        </span>
        {{ protectionDocObj.docInfo.ObjectAuthors.join(', ') }}
      </div>
      <div v-if="protectionDocObj.docInfo.ObjectCopyrightHolders">
        <span class="prt-document-title">
          Правообладател{{
            protectionDocObj.docInfo.ObjectCopyrightHolders.length > 1 ? 'и' : 'ь'
          }}:
        </span>
        {{ protectionDocObj.docInfo.ObjectCopyrightHolders.join(', ') }}
      </div>
      <div v-if="protectionDocObj.docInfo.DocumentURL">
        <span class="prt-document-title">
          Ссылка на документ:
        </span>
        <a
          :href="`${protectionDocObj.docInfo.DocumentURL}`"
          target="_blank">
          {{ cutText(protectionDocObj.docInfo.DocumentURL, 50) }}
        </a>
      </div>
      <div v-if="protectionDocObj.docInfo.ObjectAnnotation">
        <span class="prt-document-title">
          Аннотация:
        </span>
        {{ protectionDocObj.docInfo.ObjectAnnotation }}
      </div>

      <span slot="footer" class="dialog-footer">
        <button
          class="dialog-primary-btn"
          @click="protectionDocObj.docVisible = false">
          Закрыть окно
        </button>
      </span>

    </el-dialog>

  </div>
</template>

<script>
/* eslint-disable no-new */
import axios from 'axios';
import Swiper from 'swiper/dist/js/swiper';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';
import PhotoSwipe from 'photoswipe/dist/photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default';
import 'swiper/dist/css/swiper.css';

const MULTILINE_MIN_CHARS = 35;

export default {

  props: {
    title: '',
    content: '',
    objectId: '',
    reviewId: '',
    fieldName: '',
    contentScheme: {
      type: Array,
      default: () => [],
    },
    type: '',
    objType: null,
    classes: '',
    objData: null,
    objDeal: null,
  },

  data() {
    return {
      typeLocal: '',
      contentLocal: '',
      objects: [],
      images: [],
      options: null, // WidgetOptions.Options
      imagesSwipers: {
        sm: Swiper,
        md: Swiper,
      },
      imagesGallery: null,
      fieldStruct: null,
      protectionDocObj: {
        docInfo: {},
        docVisible: false,
      },
    };
  },

  mounted() {
    this.contentLocal = this.content;

    // Get field structure
    if (this.objType) {
      for (let i = 0; i < this.objType.Fields.length; i += 1) {
        if (this.objType.Fields[i].Name === this.fieldName) {
          this.fieldStruct = this.objType.Fields[i];
          break;
        }
      }
    }

    // Add classes
    if (this.classes) {
      this.$refs.appFieldWidget.classList.add(this.classes);
    }

    // Define type
    if (this.type) {
      this.typeLocal = this.type;
    } else if (
      this.fieldStruct
      && ['object', 'person'].indexOf(this.fieldStruct.Widget) > -1
    ) {
      this.typeLocal = this.fieldStruct.Widget;
    } else if (
      this.fieldStruct
      && this.fieldStruct.Widget === 'select'
    ) {
      this.typeLocal = 'option';
    } else if (Array.isArray(this.contentLocal)) {
      this.typeLocal = 'ul';
    } else if (this.contentLocal.length > MULTILINE_MIN_CHARS) {
      this.typeLocal = 'multiline';
    }
    // Init
    if (this.typeLocal === 'option') {
      if (this.fieldStruct && this.fieldStruct.WidgetOptions.Options) {
        this.options = this.fieldStruct.WidgetOptions.Options;
      } else if (
        this.fieldStruct
        && this.fieldStruct.WidgetOptions.Vocabulary
      ) {
        const vocId = this.fieldStruct.WidgetOptions.Vocabulary;
        const keysArr = Array.isArray(this.contentLocal)
          ? this.contentLocal : [this.contentLocal];
        axios.post('vocabularies/values', {
          voc: vocId, q: keysArr,
        }).then((r) => {
          this.options = {};
          this.contentLocal = [];
          keysArr.forEach((key) => {
            this.contentLocal.push(key);
            if (key && r.data[key]) {
              this.options[key] = r.data[key];
            } else {
              this.options[key] = key;
            }
          });
        });
      }
    } else if (this.typeLocal === 'object') {
      Object.keys(this.objData.Transient.RelatedLinks).forEach((id) => {
        this.objData.Transient.RelatedLinks[id].objectId = id;
        this.objects.push(this.objData.Transient.RelatedLinks[id]);
      });
    } else if (this.typeLocal === 'links') {
      let curObjId = '';
      Object.keys(this.objData.Links).forEach((id) => {
        if (this.objData.Links[id].Format === 'object') curObjId = this.objData.Links[id].Link;
        else curObjId = '';
        if (this.fieldStruct
          && this.fieldStruct.WidgetOptions.Relations[this.objData.Links[id].Relation].Title) {
          this.objData.Links[id].RelationName =
            this.fieldStruct.WidgetOptions.Relations[this.objData.Links[id].Relation].Title;
        } else {
          this.objData.Links[id].RelationName = '';
        }
        if (curObjId
          && this.objData.Transient.RelatedObjects
          && this.objData.Transient.RelatedObjects[curObjId]) {
          this.objData.Links[id].objName = this.objData.Transient.RelatedObjects[curObjId].Title;
        } else {
          this.objData.Links[id].objName = curObjId;
        }
        this.objects.push(this.objData.Links[id]);
      });
    } else if (this.typeLocal === 'images') {
      const images = [];
      this.contentLocal.forEach((image) => {
        images.push({
          hash: image.Hash,
          objectId: image.ObjectId,
          fileId: image.FileId,
          name: image.Name,
        });
      });
      axios.post('images', JSON.stringify(images)).then((response) => {
        this.images = response.data;
        this.$nextTick(() => {
          this.imagesSwipers.md = new Swiper('.im_md-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            autoHeight: true,
          });
          this.imagesSwipers.sm = new Swiper('.im_sm-container', {
            slidesPerView: 'auto',
            spaceBetween: 30,
          });
        });
      });
    } else if (this.typeLocal === 'protection-documents') {
      this.contentLocal = [];
      Object.keys(this.objData.ProtectionDocuments).forEach((id) => {
        const curProtectionDoc = this.objData.ProtectionDocuments[id];
        const relatedDocId = `${curProtectionDoc.Number}@${curProtectionDoc.RegistryId}`;
        if (this.objData.Transient.RelatedRegistryDocuments
          && this.objData.Transient.RelatedRegistryDocuments[relatedDocId]) {
          curProtectionDoc.RelatedDocument =
            this.objData.Transient.RelatedRegistryDocuments[relatedDocId];
        } else {
          curProtectionDoc.RelatedDocument = null;
        }
        this.contentLocal.push(curProtectionDoc);
      });
    }
  },

  computed: {

    person() {
      let person = '';
      if (this.contentLocal.Surname) person += this.contentLocal.Surname;
      if (this.contentLocal.Name) person += ` ${this.contentLocal.Name}`;
      if (this.contentLocal.Patronymic) person += ` ${this.contentLocal.Patronymic}`;
      return person;
    },

    personContent() {
      const authors = [];
      if (this.contentLocal && this.contentLocal.length) {
        const stakes = this.contentLocal.reduce((sum, current) => sum + current.Stake, 0);
        this.contentLocal.forEach((data, i) => {
          authors[i] = {};
          authors[i].fio = `${data.Surname} ${data.Name}`;
          authors[i].fio += data.Patronymic ? ` ${data.Patronymic}` : '';
          authors[i].stake = `${data.Stake}/${stakes}`;
          authors[i].userId = data.UserId ? data.UserId : '';
        });
      }
      return authors;
    },

  },

  methods: {

    getMarkupFragments(el) {
      const markup = JSON.parse(el.Markup);
      let fragments = 0;
      Object.keys(markup).some((key) => {
        if (typeof markup[key].total_frag !== 'undefined') {
          fragments = markup[key].total_frag;
          return true;
        }
        return false;
      });
      return fragments;
    },

    getMarkupCitations(el) {
      const markup = JSON.parse(el.Markup);
      let citations = 0;
      Object.keys(markup).some((key) => {
        if (typeof markup[key].total_cit !== 'undefined') {
          citations = markup[key].total_cit;
          return true;
        }
        return false;
      });
      return citations;
    },

    protDocTitle(protDoc) {
      let title = '';
      if (protDoc.RelatedDocument) title = `${protDoc.RelatedDocument.DocumentName} `;
      if (protDoc.Number) title += `№ ${protDoc.Number}`;
      if (title && protDoc.Description) title += ` (${protDoc.Description})`;
      else if (protDoc.Description) title = protDoc.Description;
      return title;
    },

    onProtDocClicked(relatedDoc) {
      this.protectionDocObj.docInfo = relatedDoc;
      this.protectionDocObj.docVisible = true;
    },

    onImageClicked(i, type) {
      if (type === 'sm') {
        this.imagesSwipers.md.slideTo(i);
      } else if (type === 'md') {
        const pswpElement = document.querySelectorAll('.pswp')[0];
        const items = [];
        this.images.forEach((image) => {
          items.push({
            src: this.$store.state.apiUrl + image.lg.url,
            w: image.lg.w,
            h: image.lg.h,
          });
        });
        const options = {
          index: i,
          bgOpacity: 0.5,
        };
        this.imagesGallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault,
          items, options);
        this.imagesGallery.init();
      }
    },

    onFileClicked(el) {
      if (this.objData.Transient.IsBlocked
        && !this.objData.Transient.Permissions.OBJECT_DOWNLOAD) this.$message('Объект заблокирован');
      else if (this.objDeal
        && this.objDeal.cannotMakeDeals
        && this.typeLocal !== 'files.preview'
        && this.typeLocal !== 'files.legal'
        && !this.objData.Transient.Permissions.OBJECT_DOWNLOAD) {
        this.$message(this.objDeal.Status);
      } else if (this.objDeal
        && this.objDeal.canMakeDeals
        && this.typeLocal !== 'files.preview'
        && this.typeLocal !== 'files.legal'
        && !this.objData.Transient.Permissions.OBJECT_DOWNLOAD) {
        this.$emit('onShowAccessConditions');
      } else if ((this.objDeal && this.objDeal.madeDeals)
        || this.typeLocal === 'files.preview'
        || this.typeLocal === 'files.legal'
        || this.objData.Transient.Permissions.OBJECT_DOWNLOAD) {
        const oi = (this.objectId ? this.objectId : el.ObjectId);
        let url = `objects/${oi}/link/${el.FileId}`;
        const userId = this.$store.getters['user/getUserId'];
        let data = { params: { userId: (userId || '') } };
        if (this.reviewId) {
          url = `reviews/${this.reviewId}/link`;
          data = {};
        }
        axios.get(url, data).then((r) => {
          const a = document.createElement('a');
          a.setAttribute('type', 'hidden');
          document.body.appendChild(a);
          a.download = el.Name;
          a.href = r.data;
          a.click();
          document.body.removeChild(a);
        }).catch((err) => {
          const r = err.response;
          if (r.statusText === 'Forbidden') {
            this.$message('Недостаточно прав для доступа до файла.');
          } else {
            this.$message('Ошибка в генерации доступа, попробуйте скачать позже.');
          }
        });
      }
    },

    cutText(text, size) {
      if (text.length > size) {
        return `${text.substr(0, size)}...`;
      }
      return text;
    },

    preRender(el) {
      let elProcessed = '';
      if (typeof el === 'object') {
        if (this.contentScheme) {
          // Process schemed objects
          elProcessed = [];
          this.contentScheme.forEach((key) => {
            if (el[key]) {
              elProcessed.push(el[key]);
            }
          });
          elProcessed = elProcessed.join(' ');
        } else {
          // Process objects
          elProcessed = Object.values(el).join(' ');
        }
      } else {
        // Process strings
        elProcessed = el;
      }
      return elProcessed;
    },

    previewFile(el) {
      const oi = (this.objectId ? this.objectId : el.ObjectId);
      const url = `objects/${oi}/link/${el.FileId}`;
      const userId = this.$store.getters['user/getUserId'];
      const data = { params: { userId: (userId || '') } };
      axios.get(url, data).then((r) => {
        const serviceUrl = `https://docs.google.com/viewer?url=${r.data}`;
        window.open(serviceUrl);
      }).catch((err) => {
        const r = err.response;
        if (r.statusText === 'Forbidden') {
          this.$message('Недостаточно прав для доступа до файла.');
        } else {
          this.$message('Ошибка в генерации доступа, попробуйте скачать позже.');
        }
      });
    },

    onObjectClicked(o) {
      this.$store.commit('clearActiveAjax', () => {
        this.$router.push({ path: `/object/${o.ObjectId}` });
      });
    },

  },

};
</script>

<style lang="scss">
@import "../styles/common/main";
.ob_ul {
  margin: 8px 0;
  padding-left: 30px;
  &:last-of-type {
    margin-bottom: 0;
  }
  .ob_link {
    text-decoration: underline;
    @include transition;
    cursor: pointer;
    &:hover {
      color: lighten($color-1, 15%);
      text-decoration: none;
    }
  }
}
.app-field-widget_fd {
  margin: 15px 0;
  clear: both;
  &:first-of-type {
    margin-top: 0;
  }
  &.no-margin-btm {
    margin-bottom: 0;
  }
  .fd_block {
    display: block;
    margin: 5px 0;
  }
  .fd_title {
    color: #999;
    margin-right: 5px;
    &.fd_title--block {
      margin-bottom: 8px;
      display: block;
    }
  }
  .fd_ul {
    margin: 8px 0 0;
    padding-left: 30px;
  }
  .fd_images_im {
    padding-top: 10px;
    .im_md-container {
      .swiper-slide {
        cursor: pointer;
        img {
          width: 100%;
          height: auto;
        }
      }
    }
    .im_sm-container {
      margin-top: 15px;
      .swiper-slide {
        width: auto;
        cursor: pointer;
        img {
          max-height: 70px;
          width: auto;
        }
      }
    }
  }
  .fd_files_ff {
    list-style: none;
    margin: 10px 0 0;
    padding-left: 23px;
    a {
      color: #fff;
      text-decoration: underline;
    }
    .ff_li {
      position: relative;
      margin: 7px 0;
    }
    .ff_icon {
      position: absolute;
      left: -23px;
      top: 3px;
      color: #999;
    }
    .ff_name {
      overflow: hidden;
      display: block;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      margin-right: 80px;
      @include transition;
    }
    a.ff_name {
      cursor: pointer;
      &:hover {
        color: lighten($color-1, 15%);
        text-decoration: none;
      }
    }
    .ff_size {
      position: absolute;
      right: 0;
      top: 0;
    }
    .ff_size_units {
      color: #999;
    }
    .ff_desc {
      margin-top: 5px;
      color: #999;
    }
  }
  .ob_ul {
    .link-info {
      color:#999;
    }
  }
  .prt-document-info {
    cursor: pointer;
    color: #8c84e6 !important;
    text-decoration: underline;
  }
  .prt-document-full {
    div {
      padding-top:5px;
      color: #333;
      .prt-document-title {
        color: #999;
      }
    }
  }
}
.fd_objects_fo {
  .fo_li {
    margin: 10px 0;
    cursor: pointer;
  }
  .fo_title {
    font-size: 18px;
  }
  .fo_owner {
    font-size: 16px;
    color: #999;
  }
}
.fd_color-dark {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/AppFieldWidget.vue